import gql from "graphql-tag"

export default gql`
  mutation UpdateBlocksContent(
    $stepId: Int
    $id: Int
    $contentLastModified: DateTime
    $lastPublished: DateTime
  ) {
    updateBlocksContent(
      step_id: $stepId
      id: $id
      content_last_modified: $contentLastModified
      last_published: $lastPublished
    ) {
      id
      method
      type
      data
      content_last_modified
      last_published
    }
  }
`
